<template>
  <div class="pta-admin">
    <h1 style="margin-bottom:5px;">Pipeline
      <button class="btn btn-info btn-sm m-l-20" @click.prevent="showDeals"><i class="icon-14"></i> <span class="d-sm-inline">Manage Deals</span></button>
    </h1>
    <h3 style="margin-bottom:60px;">{{ company }} <a :href="'/account/users/general-partners/'+id" target="_blank"><i class="fas fa-circle-info"></i></a></h3>
      <div class="pta-pipeline-status">
        <ul>
          <li><span>{{ investors_number }}</span>Active Deals</li>
          <li><span>${{ investors_amount | formatAmount }}</span>Average Deal Value</li>
          <li><span>{{ investors_completed }}</span>Number of <br />meetings completed</li>
        </ul>
      </div>
      <div class="pta-pipeline-sort">
        <ul>
          <li><span>Lost Deals</span></li>
          <li :class="filterInvestorForm.sort_by=='created_at'?(filterInvestorForm.order=='asc'?'active-asc':'active-desc'):''" @click.prevent="filterInvestorForm.sort_by='created_at'?(filterInvestorForm.order=='desc'?filterInvestorForm.order='asc':filterInvestorForm.order='desc'):filterInvestorForm.order='asc';filterInvestorForm.sort_by='created_at';"><span>Date created</span></li>
          <li :class="filterInvestorForm.sort_by=='name'?(filterInvestorForm.order=='asc'?'active-asc':'active-desc'):''" @click.prevent="filterInvestorForm.sort_by='name'?(filterInvestorForm.order=='desc'?filterInvestorForm.order='asc':filterInvestorForm.order='desc'):filterInvestorForm.order='asc';filterInvestorForm.sort_by='name';"><span>Name</span></li>
          <li :class="filterInvestorForm.sort_by=='amount'?(filterInvestorForm.order=='asc'?'active-asc':'active-desc'):''" @click.prevent="filterInvestorForm.sort_by='amount'?(filterInvestorForm.order=='desc'?filterInvestorForm.order='asc':filterInvestorForm.order='desc'):filterInvestorForm.order='asc';filterInvestorForm.sort_by='amount';"><span>Value</span></li>
          <li :class="filterInvestorForm.sort_by=='closed_at'?(filterInvestorForm.order=='asc'?'active-asc':'active-desc'):''" @click.prevent="filterInvestorForm.sort_by='closed_at'?(filterInvestorForm.order=='desc'?filterInvestorForm.order='asc':filterInvestorForm.order='desc'):filterInvestorForm.order='asc';filterInvestorForm.sort_by='closed_at';"><span>Close date</span></li>
          <li :class="filterInvestorForm.sort_by=='updated_at'?(filterInvestorForm.order=='asc'?'active-asc':'active-desc'):''" @click.prevent="filterInvestorForm.sort_by='updated_at'?(filterInvestorForm.order=='desc'?filterInvestorForm.order='asc':filterInvestorForm.order='desc'):filterInvestorForm.order='asc';filterInvestorForm.sort_by='updated_at';"><span>Last updates</span></li>
          <li :class="filterInvestorForm.sort_by=='pd_stage_id'?(filterInvestorForm.order=='asc'?'active-asc':'active-desc'):''" @click.prevent="filterInvestorForm.sort_by='pd_stage_id'?(filterInvestorForm.order=='desc'?filterInvestorForm.order='asc':filterInvestorForm.order='desc'):filterInvestorForm.order='asc';filterInvestorForm.sort_by='pd_stage_id';"><span>Deal Stage</span></li>
        </ul>
      </div>
      <div class="pta-pipeline-campaigns">
        <div class="pta-pipeline-campaign" v-for="investor in investors.data">
          <div class="pta-pipeline-campaign-left">
            <h3>{{ investor.name }} <a :href="'/account/investors/'+investor.investor_id" target="_blank"><i class="fas fa-circle-info"></i></a> <span style="font-weight:400;display:inline-block;font-size:14px;" v-if="investor.completed_at">(Campaign is completed)</span><span style="font-weight:400;display:inline-block;font-size:14px;" v-else-if="investor.stopped_at">(Campaign is stopped)</span><span style="font-weight:400;display:inline-block;font-size:14px;" v-else-if="investor.paused_at">(Campaign is paused)</span></h3>
          </div>
          <div class="pta-pipeline-campaign-left">
            <ul class="pta-pipeline-statusline pta-pipeline-size-13" :data-id="'inv-stage-'+investor.pd_stage_id" :class="show_index==investor.id?'pta-pipeline-show-labels pta-pipeline-color-'+investor.color_id:'pta-pipeline-color-'+investor.color_id">
              <li v-for="(pipeline_stage, index) in pipeline_stages" :data-id="'stage-'+pipeline_stage.pd_stage_id" :class="isActiveStage(index,investor.pd_stage_id)"><div><span>{{ pipeline_stage.name }}</span></div></li>
              <!--
              investor.pd_stage_id>=pipeline_stage.pd_stage_id?'active':''
              <li :class="investor.pd_stage_id>0?'active':''"><div><span>Conversation started</span></div></li>
              <li :class="investor.pd_stage_id>investor.pd_first_stage_id+0?'active':''"><div><span>Fact Sheet</span></div></li>
              <li :class="investor.pd_stage_id>investor.pd_first_stage_id+1?'active':''"><div><span>Presentation</span></div></li>
              <li :class="investor.pd_stage_id>investor.pd_first_stage_id+2?'active':''"><div><span>Team Bios</span></div></li>
              <li :class="investor.pd_stage_id>investor.pd_first_stage_id+3?'active':''"><div><span>Case Studies</span></div></li>
              <li :class="investor.pd_stage_id>investor.pd_first_stage_id+4?'active':''"><div><span>FAQ/DDQ</span></div></li>
              <li :class="investor.pd_stage_id>investor.pd_first_stage_id+5?'active':''"><div><span>Track Record</span></div></li>
              <li :class="investor.pd_stage_id>investor.pd_first_stage_id+6?'active':''"><div><span>Financial Model</span></div></li>
              <li :class="investor.pd_stage_id>investor.pd_first_stage_id+7?'active':''"><div><span>Key Terms</span></div></li>
              <li :class="investor.pd_stage_id>investor.pd_first_stage_id+8?'active':''"><div><span>Market Reports</span></div></li>
              <li :class="investor.pd_stage_id>investor.pd_first_stage_id+9?'active':''"><div><span>Other Marketing Materials</span></div></li>
              <li :class="investor.pd_stage_id>investor.pd_first_stage_id+10?'active':''"><div><span>Data Room provided</span></div></li>
              <li :class="investor.pd_stage_id>investor.pd_first_stage_id+11?'active':''"><div><span>Meeting completed</span></div></li> -->
            </ul>
            <i @click.prevent="show_index==investor.id?show_index=0:show_index=investor.id" class="pta-pipeline-icon-show" :class="show_index==investor.id?'pta-pipeline-icon-hide':''"></i>
          </div>
          <div class="pta-pipeline-campaign-right">
            <span class="pta-pipeline-amount">${{ investor.amount | formatAmount }}</span>
            <span class="pta-pipeline-date">{{ investor.updated_at | momentDate }}</span>
          </div>
          <div class="pta-pipeline-action-buttons" v-if="investor.type=='auto'">
            <ul>
              <li v-if="!investor.stopped_at && !investor.paused_at && !investor.completed_at" v-confirm="{ok: confirmPause(investor)}" v-tooltip="'Pause campaign'"><i class="fas fa-pause"></i> Pause campaign</li>
              <li v-if="!investor.stopped_at && investor.paused_at && !investor.completed_at" v-confirm="{ok: confirmResume(investor)}" v-tooltip="'Resume campaign'"><i class="fas fa-play"></i> Resume campaign</li>
              <li v-if="!investor.stopped_at && !investor.completed_at" v-confirm="{ok: confirmStop(investor)}" v-tooltip="'Stop campaign'"><i class="fas fa-stop"></i> Stop campaign</li>
              <li v-if="!investor.completed_at" :class="!investor.transcripts.length?'pta-disable':''" v-tooltip="investor.transcripts.length?'Complete campaign':'No transcript found.'" v-confirm="{ok: confirmComplete(investor)}"><i class="fas fa-circle-check"></i> Complete campaign</li>
            </ul>
          </div>
          <div class="pta-pipeline-buttons" style="margin-top: -46px;">
            <a class="pta-pipeline-button" v-if="investor.investor" :href="'https://proptecham.ai/account/investors/'+investor.investor.id+'/profile/'+id">View Profile</a>
            <a class="pta-pipeline-button" v-if="investor.investor && investor.investor.website" :href="investor.investor.website.startsWith('http')?investor.investor.website.split(',')[0].trim():'https://'+investor.investor.website.split(',')[0].trim()" target="_blank">View website</a>
            <span class="pta-pipeline-button" :class="(investor.investor)?'':'pta-pipeline-button-disable'" @click.prevent="(investor.investor)?showNotes(investor.id,investor.investor_notes):false">Notes</span>
            <a class="pta-pipeline-button" v-if="investor.investor" :href="'https://proptecham.ai/account/investors/'+investor.investor.id+'/notes'" target="_blank">Internal Notes</a>
            <!-- <span class="pta-pipeline-button" @click.prevent="showDealHistory(investor.id)">Deal history</span>
            <span class="pta-pipeline-button" @click.prevent="selected_index==investor.id?selected_index=0:selected_index=investor.id;selected_history_index=0;">View details</span> -->
          </div>
          <div class="pta-pipeline-campaign-details" v-if="selected_notes_index==investor.id">
            <div class="row">
              <div class="col-12 col-sm-12" v-if="investor.investor_notes && investor.investor_notes.length">
                <h4>{{ investor.investor_notes.length }} notes found. <i @click="showNoteCreatePanel = !showNoteCreatePanel" v-if="!showNoteCreatePanel" class="fas fa-plus-circle" style="cursor: pointer;"></i></h4>
              <div class="table-responsive">
                <table class="table table-hover">
                  <tbody>
                  <tr v-for="note in investor.investor_notes" v-if="note.user_investor_id==selected_notes_index">
                    <td v-if="!note.pd_id">
                      <span style="display:block;margin-bottom:5px;font-size:12px;line-height:18px;" v-if="note.creator_user">created by {{ note.creator_user.profile.first_name }} on {{ note.created_at | moment }}</span>
                      <span style="display:block;margin-bottom:5px;font-size:12px;line-height:18px;" v-if="!note.creator_user">created by {{ note.creator_user_name }} on {{ note.created_at | moment }}</span>
                      {{ note.text }}
                    </td>
                    <td v-if="note.pd_id">
                      <span style="display:block;margin-bottom:5px;font-size:12px;line-height:18px;" v-if="note.creator_user">created by {{ note.creator_user.profile.first_name }} on {{ note.created_at | moment }}</span>
                      <span style="display:block;margin-bottom:5px;font-size:12px;line-height:18px;" v-if="!note.creator_user">created by {{ note.creator_user_name }} on {{ note.created_at | moment }}</span>
                      <span v-html="note.text"></span>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              </div>
              <div class="col-12 col-sm-12" v-else-if="!showNoteCreatePanel">
                <h4>No notes available. <i @click="showNoteCreatePanel = !showNoteCreatePanel" v-if="!showNoteCreatePanel" class="fas fa-plus-circle" style="cursor: pointer;"></i></h4>
              </div>
              <div class="col-12 col-sm-12" v-if="showNoteCreatePanel && selected_notes_index==investor.id">
                <form @submit.prevent="submitInvestorNote(investor.investor_id)" @keydown="investorNoteForm.errors.clear($event.target.name)" autocomplete="off">
                  <div class="row">
                    <div class="col-12 col-sm-12">
                      <div class="row">
                        <div class="col-12">
                          <div class="form-group">
                            <label for="" style="font-size:16px;">New note</label>
                            <autosize-textarea placeholder="" v-model="investorNoteForm.text" rows="2" name="text"></autosize-textarea>
                            <show-error :form-name="investorNoteForm" prop-name="text"></show-error>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <button type="submit" class="btn btn-info waves-effect waves-light pull-right">{{trans('general.add')}}</button>
                  <button type="button" class="btn btn-danger waves-effect waves-light pull-right m-r-10" @click="showNoteCreatePanel = !showNoteCreatePanel">{{trans('general.cancel')}}</button>
                </form>
              </div>
            </div>
          </div>
          <div class="pta-pipeline-campaign-details" v-if="selected_index==investor.id">
            <div class="row">
              <div class="col-12 col-sm-12" v-if="investor.investor_contact">
                Contact person: {{ investor.investor_contact.first_name }} {{ investor.investor_contact.last_name }}<br />
                Contact email: <a :href="'mailto:'+investor.investor_contact.email_work">{{ investor.investor_contact.email_work }}</a><br />
                Contact phone: {{ investor.investor_contact.phone_work?investor.investor_contact.phone_work:'' }}
              </div>
              <div class="col-12 col-sm-12" v-else>
                No contact found.
              </div>
            </div>
            <div class="row" v-if="investor.description">
              <div class="col-12 col-sm-12">
                Description:<br />
                {{ investor.description }}
              </div>
            </div>
          </div>
          <div class="pta-pipeline-campaign-details" v-if="selected_history_index==investor.id">
            <h4 class="card-title">History</h4>
            <div class="pta-timeline" v-if="emails_pipeline">
                <div style="cursor:pointer;" @click="showEmail(emails_pipeline_entry)" class="pta-timeline-container" :class="'pta-timeline-'+emails_pipeline_entry.type" v-for="emails_pipeline_entry in emails_pipeline">
                <div class="pta-timeline-content">
                  <h2>{{ emails_pipeline_entry.subject }}</h2>
                  <p style="margin-bottom:0;" v-if="emails_pipeline_entry.subject!='Note'">{{ emails_pipeline_entry.info }}<br />{{ emails_pipeline_entry.from }}<br />{{ emails_pipeline_entry.to }}</p>
                  <p style="margin-bottom:0;" v-if="emails_pipeline_entry.subject=='Note'">{{ emails_pipeline_entry.info }}<br />{{ emails_pipeline_entry.from }}<br />{{ emails_pipeline_entry.to }}<br />{{ emails_pipeline_entry.body }}</p>
                </div>
              </div>
            </div>
<div v-else>
            No history information available yet.
</div>
          </div>
        </div>

    </div>

    <div id="modalDeals" class="modal fade">
      <div class="modal-dialog" style="max-width:920px;">
        <div class="modal-content">
          <div class="modal-header" style="display:block;">
            <button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">×</span> <span class="sr-only">close</span></button>
            <h4 id="modalTitle" class="modal-title">Deals</h4>
          </div>
          <div id="modalBody" class="modal-body" style="font-size:18px;line-height:24px;">
            <div class="row">
            <div class="col-12 col-sm-12 pta-content-quest">
              <h4 class="card-title">&nbsp;<button class="btn btn-info btn-sm pull-right m-r-10" v-if="!showCreatePanel && has_uploads" @click="showCreatePanel = !showCreatePanel"><i class="fas fa-plus"></i> <span class="d-none d-sm-inline">Add Investor</span></button>
              </h4>
              <transition name="fade">
                <div class="card border-bottom" v-if="showCreatePanel">
                  <div class="card-body p-4" style="background:#efefef;">
                    <!-- <h4 class="card-title">{{trans('user.add_new_user')}}</h4> -->
                    <form @submit.prevent="submit" @keydown="userInvestorForm.errors.clear($event.target.name)" autocomplete="off">
                      <div class="row">
                        <div class="col-12 col-sm-12">
                          <div class="row">
                            <div class="col-12">
                              <div class="form-group">
                                <label for="">Investors</label>
                                <v-select label="name" track-by="id" v-model="investor" name="investor_id" id="investor_id" :options="investors_search.data" :placeholder="'Enter investor name to search ...'" :multiple="false" :close-on-select="true" :clear-on-select="false" :showNoOptions="false" :hide-selected="true" placeholder="Enter investor name to search ..." selectLabel="choose" @search-change="val => searchInvestor(val)"></v-select>
                                <show-error :form-name="userInvestorForm" prop-name="investor_id"></show-error>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <button type="submit" class="btn btn-info waves-effect waves-light pull-right">{{trans('general.add')}}</button>
                      <button type="button" class="btn btn-danger waves-effect waves-light pull-right m-r-10" @click="showCreatePanel = !showCreatePanel">{{trans('general.cancel')}}</button>
                    </form>
                  </div>
                </div>
              </transition>
              <div class="card" v-if="user_investors.total">
                <div class="card-body" style="padding:0;">
                  <div class="table-responsive" v-if="hasPermission('list-user') && user_investors.total">
                    <table class="table table-hover">
                      <thead>
                      <tr>
                        <th scope="col">{{trans('investor.name')}}</th>
                        <th scope="col">Value</th>
                        <th scope="col" class="table-option"></th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="investor in user_investors.data">
                        <td v-text="investor.name"></td>
                        <td>
                          <input v-if="editIndex==investor.id" class="form-control" value="" v-model="editInvestor.amount" :name="'amount_'+investor.id" />
                          <show-error v-if="editIndex==investor.id" :form-name="editInvestorForm" prop-name="amount"></show-error>
                          <span v-if="editIndex!=investor.id">{{ investor.amount }}</span>
                        </td>
                        <td class="table-option">
                          <div class="btn-group">
                            <button class="btn btn-info btn-sm" v-if="editIndex==investor.id" @click="updateInvestor(investor)" v-tooltip="'Save value'"><i class="fas fa-save"></i></button>
                            <button class="btn btn-info btn-sm" v-if="editIndex!=investor.id" @click="startEdit(investor)" v-tooltip="'Edit value'"><i class="fas fa-pencil-alt"></i></button>
                            <button class="btn btn-danger btn-sm" :key="investor.id" v-if="hasPermission('delete-user')" v-confirm="{ok: confirmDelete(investor)}" v-tooltip="'Remove investor'"><i class="fas fa-trash"></i></button>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div v-else-if="!has_uploads">The user must upload a fact sheet, presentation and their team bios first!</div>
              <div v-else>No investors assigned.</div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>
<script>
import vSelect from 'vue-multiselect'
import autosizeTextarea from "../../components/autosize-textarea.vue";
export default {
  components: {autosizeTextarea, vSelect},
  mounted(){
    this.getUserPipelineStages();
    this.getQuestionnaire();
  },
  methods: {
    showDealHistory(id){
      this.selected_index = 0;
      this.selected_notes_index = 0;
      if(this.selected_history_index == id){
        this.selected_history_index = 0;
      }else{
        this.fetchSalesPipeline(id);
      }
    },
    showNotes(id,investor_notes){
      this.selected_index = 0;
      this.selected_history_index = 0;
      if(this.selected_notes_index == id){
        this.selected_notes_index = 0;
      }else{
        this.selected_notes_index = id;
      }
    },
    submitInvestorNote(investor_id){
      this.investorNoteForm.investor_id         = investor_id;
      this.investorNoteForm.user_investor_id    = this.selected_notes_index;
      this.investorNoteForm.post('/api/investor-note')
          .then(response => {
            toastr.success(response.message);
            this.getUserInvestors();
          })
          .catch(error => {
            helper.showErrorMsg(error);
          });
    },
    hasPermission(permission){
      return helper.hasPermission(permission);
    },
    confirmDelete(investor){
      return dialog => this.deleteInvestor(investor);
    },
    deleteInvestor(investor){
      axios.delete('/api/user-investor/'+investor.id)
          .then(response => response.data)
          .then(response => {
            toastr.success(response.message);
            this.getUserInvestorsList();
          }).catch(error => {
        helper.showDataErrorMsg(error);
      });
    },
    startEdit(investor){
      this.editInvestor = investor;
      this.editIndex = investor.id;
    },
    updateInvestor(investor){
      this.editInvestorForm.amount = investor.amount;
      this.editInvestorForm.patch('/api/user-investor/'+investor.id+'/set-amount')
          .then(response => {
            toastr.success(response.message);
            this.editIndex = 0;
            this.editInvestor = null;
            this.editInvestorForm.amount = 0;
            this.getUserInvestors();
          })
          .catch(error => {
            // toastr.error('Name muss ausgefüllt sein');
            if(error.errors.message){
              toastr.error(error.errors.message);
            }else{
              helper.showDataErrorMsg(error);
            }
            //  console.log(error.errors.message);

          });
    },
    confirmPause(investor){
      return dialog => this.pauseInvestorCampaign(investor);
    },
    pauseInvestorCampaign(investor){
      axios.post('/api/user-investor/'+investor.id+'/pause')
          .then(response => response.data)
          .then(response => {
            this.investors.data.forEach(function (item) {
              if(investor.id==item.id){
                item.stopped_at = response.user_investor.stopped_at;
                item.paused_at = response.user_investor.paused_at;
              }
            });
            toastr.success(response.message);
          }).catch(error => {
        helper.showDataErrorMsg(error);
      });
    },
    confirmStop(investor){
      return dialog => this.stopInvestorCampaign(investor);
    },
    stopInvestorCampaign(investor){
      axios.post('/api/user-investor/'+investor.id+'/stop')
          .then(response => response.data)
          .then(response => {
            this.investors.data.forEach(function (item) {
              if(investor.id==item.id){
                item.stopped_at = response.user_investor.stopped_at;
                item.paused_at = response.user_investor.paused_at;
              }
            });
            toastr.success(response.message);
          }).catch(error => {
        helper.showDataErrorMsg(error);
      });
    },
    completeInvestorCampaign(investor){
      axios.post('/api/user-investor/'+investor.id+'/complete')
          .then(response => response.data)
          .then(response => {
            this.investors.data.forEach(function (item) {
              if(investor.id==item.id){
                item.completed_at = response.user_investor.completed_at;
              }
            });
            toastr.success(response.message);
          }).catch(error => {
        helper.showDataErrorMsg(error);
      });
    },
    confirmComplete(investor){
      return dialog => this.completeInvestorCampaign(investor);
    },
    confirmResume(investor){
      return dialog => this.resumeInvestorCampaign(investor);
    },
    resumeInvestorCampaign(investor){
      axios.post('/api/user-investor/'+investor.id+'/resume')
          .then(response => response.data)
          .then(response => {

            this.investors.data.forEach(function (item) {
              if(investor.id==item.id){
                item.stopped_at = response.user_investor.stopped_at;
                item.paused_at = response.user_investor.paused_at;
              }
            });

            toastr.success(response.message);
          }).catch(error => {
        helper.showDataErrorMsg(error);
      });
    },
    showDeals(){
      axios.get('/api/user/'+this.id)
          .then(response => response.data)
          .then(response => {
            this.user = response.user;
            this.upload_token = response.user.profile.upload_token;
            this.isMinUploads();
          })
          .catch(error => {
            helper.showDataErrorMsg(error);
            this.$router.push('/user/general-partners');
          })

      this.getUserInvestorsList();
    },
    fetchSalesPipeline(id){
      axios.get('/api/investor/'+id+'/emails-pipeline')
          .then(response => response.data)
          .then(response => {
            this.emails_pipeline = response;
            this.selected_history_index = id;
          })
          .catch(error => {

          })
    },
    showEmail(email){
      this.cur_email = email;
      $('#modalEmail').modal();
    },
    getQuestionnaire(){
      axios.get('/api/user/'+this.id+'/questionnaire/')
          .then(response => response.data)
          .then(response => {
            this.is_premium = response.user.profile.is_premium;
            this.company = response.user.profile.company;
          })
          .catch(error => {
            helper.showDataErrorMsg(error)
          });
    },
    isActiveStage(index,investor_stage_id){
      let stage_props = {
        index_cur: 0,
        investor_stage_id: investor_stage_id
      };
      this.pipeline_stages.forEach(function (item_stage) {
        if(item_stage.pd_stage_id == stage_props.investor_stage_id){
          stage_props.index_cur = item_stage.position;
        }
      }.bind(stage_props));
      // console.log("ic "+stage_props.index_cur);
      if(stage_props.index_cur>index){
        return 'active';
      }else{
        return '';
      }
    },
    getUserInvestorsList(){
      axios.get('/api/user-investors/'+this.id)
          .then(response => response.data)
          .then(response => {
            this.user_investors = response;
          })
          .catch(error => {
            helper.showDataErrorMsg(error)
          });
    },
    searchInvestor(name){
      axios.get('/api/investor-contact?name=' + encodeURI(name))
          .then(response => response.data)
          .then(response => {
            this.investors_search = response;
          })
          .catch(error => {
            helper.showDataErrorMsg(error)
          });
    },
    getUserInvestors(page){
      if (typeof page !== 'number') {
        page = 1;
      }
      this.filterInvestorForm.user_id = this.id;
      let url = helper.getFilterURL(this.filterInvestorForm);
      axios.get('/api/user-investor?page=' + page + url)
          .then(response => response.data)
          .then(response => {
            this.investors = response;
            this.investors_number = this.investors.data.length;
            let investors_amount_sum = 0;
            this.investors_completed = 0;
            this.investors.data.forEach(function (item) {
              // investors_amount_sum += item.amount;
              this.investors_amount += item.amount;
              if(this.last_stage_id==item.pd_stage_id){
                this.investors_completed++;
              }
            }.bind(this));

            if(this.investors_amount && this.investors_number){
              this.investors_amount = (this.investors_amount / this.investors_number);
            }else{
              this.investors_amount = 0;
            }

            /* if(investors_amount_sum && this.investors_number){
              this.investors_amount = (investors_amount_sum / this.investors_number);
            }else{
              this.investors_amount = 0;
            }*/
          })
          .catch(error => {
            helper.showDataErrorMsg(error)
          });
    },
    getUserPipelineStages(){
      axios.get('/api/user-pipeline-stages/'+this.id)
          .then(response => response.data)
          .then(response => {
            this.pipeline_stages = response;

            this.pipeline_stages.forEach(function (item) {
              if(item.position==13){
                this.last_stage_id = item.pd_stage_id;
              }
            }.bind(this));

            this.getUserInvestors();
          })
          .catch(error => {
            helper.showDataErrorMsg(error)
          });
    },
    isMinUploads(){
      axios.get('/api/upload/is-min-uploads?token=' + encodeURI(this.upload_token))
          .then(response => response.data)
          .then(response => {
            this.has_uploads = response;
            $('#modalDeals').modal();
          })
          .catch(error => {
            helper.showDataErrorMsg(error)
          });
    },
    submit(){
      if(!this.is_sended){
        this.is_sended = true;
        this.userInvestorForm.user_id                 = this.id;
        this.userInvestorForm.investor_id             = this.investor.investor.id;
        this.userInvestorForm.investor_contact_id     = this.investor.id;
        this.userInvestorForm.name                    = this.investor.investor.name;
        this.userInvestorForm.cp_first_name           = this.investor.first_name;
        this.userInvestorForm.cp_last_name            = this.investor.last_name;
        this.userInvestorForm.cp_email                = this.investor.email_work;
        this.userInvestorForm.type                    = "auto";

        this.userInvestorForm.post('/api/user-investor')
            .then(response => {
              toastr.success(response.message);
              this.investor = '';
              this.getUserInvestorsList();
              this.is_sended = false;
            })
            .catch(error => {
              helper.showErrorMsg(error);
              this.is_sended = false;
            });
      }
    },
  },
  data() {
    return {
      filterInvestorForm: {
        sort_by : 'created_at',
        order: 'asc',
        user_id: '',
        page_length: 10000
      },
      editInvestorForm: new Form({
        amount: 0
      }),
      investorNoteForm: new Form({
        investor_id: '',
        user_investor_id: '',
        title: '',
        text: ''
      },true),
      user: '',
      emails_pipeline: '',
      upload_token: '',
      user_investors: {
        total: 0,
        data: []
      },
      cur_email: '',
      pta_sort_by: 'created',
      pta_sort_dir: 'asc',
      selected_index: 0,
      show_index: 0,
      cur_user: '',
      investor:'',
      id:this.$route.params.id,
      cur_user_id: this.$route.params.id,
      first_stage_id: 0,
      last_stage_id: 0,
      cur_stage_index: 0,
      investors: '',
      investors_search: {
        total: 0,
        data: []
      },
      pipeline_stages: '',
      investors_number: 0,
      investors_amount: 0,
      investors_completed: 0,
      selected_history_index: 0,
      selected_notes_index: 0,
      is_premium: false,
      company: '',
      showCreatePanel: false,
      showNoteCreatePanel: false,
      has_uploads: false,
      is_sended: false,
      investors_list: {
        total: 0,
        data: []
      },
      editInvestor: null,
      editIndex: '',
      userInvestorForm: new Form({
        user_id: '',
        investor_id: '',
        investor_contact_id: '',
        cp_first_name: '',
        cp_last_name: '',
        cp_email: '',
        name: '',
        type: ''
      },true),
    }
  },
  computed: {

  },
  filters: {
    momentDate(date) {
      return helper.formatDate(date);
    },
    formatAmount(amount){
      return helper.formatAmount(amount);
    },
    moment(date) {
      return helper.formatDateTime(date);
    }
  },
  watch: {
    filterInvestorForm: {
      handler(val){
        this.getUserInvestors();
      },
      deep: true
    }
  },
}
</script>
<style scope>
body{
  background:#f4f9fb;
}

.pta-pipeline-icon-show{
  display:inline-block;
  height:20px;
  width:20px;
  background:transparent url(/images/icon_show.svg) no-repeat top left;
  background-size:100% auto;
  margin-left:-10px;
  cursor: pointer;
}
.pta-pipeline-icon-show.pta-pipeline-icon-hide{
  background-image:url(/images/icon_hide.svg);
}
.pta-pipeline-statusline{
  list-style: none;
  margin:0;
  padding:0;
  margin-top:5px;
  width:calc(100% - 30px);
  display:inline-block;
}
.pta-pipeline-statusline:after{
  content: "";
  clear: both;
  display: table;
}
.pta-pipeline-size-6 li{
  float:left;
  width:calc(20% - 4px);
  height:20px;
  position: relative;
}
.pta-pipeline-campaign-details{
  padding-top:20px;
  font-size:16px;
  clear:left;
}
.pta-pipeline-size-6 li:first-child{
  float:left;
  width:20px;
  height:20px;
  position: relative;
}
.pta-pipeline-size-9 li{
  float:left;
  width:calc(11.1111111% - 4px);
  height:20px;
  position: relative;
}
.pta-pipeline-size-9 li:first-child{
  float:left;
  width:20px;
  height:20px;
  position: relative;
}
.pta-pipeline-size-12 li{
  float:left;
  width:calc(9.09090909% - 4px);
  height:20px;
  position: relative;
}
.pta-pipeline-size-12 li:first-child{
  float:left;
  width:20px;
  height:20px;
  position: relative;
}
.pta-pipeline-size-13 li{
  float:left;
  width:calc(8.3333333333% - 4px);
  height:20px;
  position: relative;
}
.pta-pipeline-size-13 li:first-child{
  float:left;
  width:20px;
  height:20px;
  position: relative;
}
.pta-pipeline-statusline li div{
  position: absolute;
  height:20px;
  width:20px;
  right:0;
  top:0;
  z-index:3;
}
.pta-pipeline-statusline.pta-pipeline-show-labels li div span {
  display: block;
}
.pta-pipeline-statusline li div span{
  display:none;
  position:absolute;
  top:-40px;
  background:#000;
  color:#fff;
  font-size:12px;
  padding:5px 10px;
  border-radius: 5px;
  white-space:nowrap;
  left:-18px;
}
.pta-pipeline-statusline li div span:after{
  content: '';
  width: 16px;
  position: absolute;
  bottom: -8px;
  left: 20px;
  height: 14px;
  background:transparent url(/images/icon_arrow_sort_down.svg) no-repeat top left;
  background-size:100% auto;
}
.pta-pipeline-statusline li div:hover span{
  display:inline-block;
}
.pta-pipeline-statusline li:after{
  content:'';
  width:100%;
  position: absolute;
  top:7px;
  left:0;
  height:6px;
  border-top:1px solid #cccccc;
  border-bottom:1px solid #cccccc;
  z-index:1;
  background:#efefef;
}
.pta-pipeline-statusline li:before{
  content:'';
  width:20px;
  position: absolute;
  top:0px;
  right:0;
  height:20px;
  background:#efefef;
  border:1px solid #cccccc;
  border-radius: 20px;
  z-index:2;
}
.pta-pipeline-statusline.pta-pipeline-color-1 li.active:before,
.pta-pipeline-statusline.pta-pipeline-color-1 li.active:after{
  border:0;
  background-color:#f69d1d;
}
.pta-pipeline-statusline.pta-pipeline-color-2 li.active:before,
.pta-pipeline-statusline.pta-pipeline-color-2 li.active:after{
  border:0;
  background-color:#8b84ca;
}
.pta-pipeline-statusline.pta-pipeline-color-3 li.active:before,
.pta-pipeline-statusline.pta-pipeline-color-3 li.active:after{
  border:0;
  background-color:#f86e54;
}
.pta-pipeline-statusline.pta-pipeline-color-4 li.active:before,
.pta-pipeline-statusline.pta-pipeline-color-4 li.active:after{
  border:0;
  background-color:#19d18b;
}
.pta-pipeline-statusline.pta-pipeline-color-5 li.active:before,
.pta-pipeline-statusline.pta-pipeline-color-5 li.active:after{
  border:0;
  background-color:#b57ed1;
}



.pta-pipeline-campaign{
  border-radius:10px;
  background:#fff;
  padding:20px;
  margin-top:20px;
}
.pta-pipeline-campaign:after{
  content: "";
  clear: both;
  display: table;
}
.pta-pipeline-campaign span{
  display:block;
}
.pta-pipeline-campaign h3{
  font-weight:600;
  font-size:20px;
  line-height:26px;
}
.pta-pipeline-campaign h4{
  font-weight:400;
  font-size:16px;
  margin-bottom:10px;
}
.pta-pipeline-amount{
  font-weight:600;
  font-size:22px;
  text-align: right;
  margin-top:-20px;
}
.pta-pipeline-campaign span.pta-pipeline-date{
  font-size:16px;
  line-height:16px;
  text-align: right;
  display:inline-block;
  padding-left:24px;
  background: transparent url(/images/icon_calendar.svg) no-repeat left top;
  background-size: auto 100%;
  float: right;
  margin-top: 4px;
}
.pta-pipeline-campaign-right,
.pta-pipeline-campaign-left{
  float:left;
}
.pta-pipeline-campaigns .pta-pipeline-campaign-right{
  width:140px;
}
.pta-pipeline-campaigns .pta-pipeline-campaign-left{
  width:calc(100% - 140px);
  padding-right:20px;
  clear:left;
}
.pta-pipeline-campaigns{
  margin-top:20px;
}
.pta-pipeline-buttons{
  clear: both;
  text-align: right;
  padding-top:10px;
}
.pta-pipeline-action-buttons{
  clear: both;
  padding-top:10px;
}
.pta-pipeline-action-buttons ul{
  list-style: none;
  margin:0;
  padding:0;
}
.pta-pipeline-action-buttons ul li{
  margin-right: 10px;
  border:1px solid #999;
  border-radius: 10px;
  cursor:pointer;
  display:inline-block;
  font-size:14px;
  line-height:30px;
  padding:0 10px;
}
.pta-pipeline-action-buttons ul li.pta-disable{
  opacity: 0.1;
  cursor:inherit;
}
.pta-pipeline-action-buttons ul li i{
  margin-right: 5px;
}
.pta-pipeline-action-buttons ul li:hover{
  background-color: #34A7C2;
  color:#fff;
  border-color: #34A7C2;
}
.pta-pipeline-action-buttons ul li.pta-disable:hover{
  background-color: #fff;
  color:#343434;
  border-color: #999;
}

.pta-pipeline-campaign .pta-pipeline-button {
  background: #34A7C2;
  display: inline-block;
  text-transform: uppercase;
  font-size: 14px;
  line-height: 14px;
  padding: 8px 10px;
  color: #fff;
  text-decoration: none;
  border-radius: 5px;
  cursor:pointer;
  text-align:center;
  margin-left:10px;
}
.pta-pipeline-campaign .pta-pipeline-button.pta-pipeline-button-disable{
  background:#ccc;
  cursor: inherit;
}

.pta-pipeline-sort ul{
  list-style:none;
  width:100%;
  margin:0;
  padding:0;
}
.pta-pipeline-sort ul:after{
  content: "";
  clear: both;
  display: table;
}
.pta-pipeline-sort ul li{
  float:left;
  width:14.2857143%;
  background:#ffffff;
  padding:10px;
  font-size:14px;
  line-height: 14px;
  text-align: center;
  font-weight: 600;
  cursor:pointer;
}
.pta-pipeline-sort ul li.active-desc,
.pta-pipeline-sort ul li.active-asc{
  background-color:#34A7C2;
  color:#fff;
}
.pta-pipeline-sort ul li.active-desc span{
  background-image:url(/images/icon_arrow_sort_down_white.svg);
}
.pta-pipeline-sort ul li.active-asc span{
  background-image:url(/images/icon_arrow_sort_top_white.svg);
}
.pta-pipeline-sort ul li span{
  display: inline-block;
  padding-left:20px;
  background:transparent url(/images/icon_arrow_sort_topdown.svg) no-repeat left center;
  background-size:10px auto;
}
.pta-pipeline-sort ul li:last-child{
  -webkit-border-bottom-right-radius: 10px;
  -moz-border-radius-bottomright: 10px;
  border-bottom-right-radius: 10px;
}
.pta-pipeline-sort ul li:first-child{
  -webkit-border-bottom-left-radius: 10px;
  -moz-border-radius-bottomleft: 10px;
  border-bottom-left-radius: 10px;
  color:#ccc;
  cursor:inherit;
}
.pta-pipeline-sort ul li:first-child span{
  background:none;
  padding-left:0;
}


.pta-pipeline-status ul{
  list-style:none;
  width:100%;
  margin:0;
  padding:0;
  margin-bottom:4px;
}
.pta-pipeline-status ul:after{
  content: "";
  clear: both;
  display: table;
}
.pta-pipeline-status ul li{
  float:left;
  margin-right:4px;
  width:calc(30% - 3px);
  background:#ffffff;
  text-align:center;
  height:110px;
  padding:20px 20px 0;
  font-size:16px;
}
.pta-pipeline-status ul li span{
  display:block;
  font-size:24px;
  font-weight:600;
  margin-bottom:0px;
}
.pta-pipeline-status ul li span i{
  font-style: normal;
  font-size:18px;
}
.pta-pipeline-status ul li:nth-child(2){
  width:calc(40% - 3px);
}
.pta-pipeline-status ul li:last-child{
  margin-right:0px;
  -webkit-border-top-right-radius: 10px;
  -moz-border-radius-topright: 10px;
  border-top-right-radius: 10px;
}
.pta-pipeline-status ul li:first-child{
  -webkit-border-top-left-radius: 10px;
  -moz-border-radius-topleft: 10px;
  border-top-left-radius: 10px;
}
</style>